(function () {
  'use strict';
  var A = window.ascendic || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || A.moneyFormat || '{{amount_no_decimals_with_comma_separator}} kr.';
    function fmt(n, dec, th, ds) {
      dec = dec == null ? 2 : dec; th = th || ','; ds = ds || '.';
      if (isNaN(n) || n == null) return 0;
      n = (n / 100.0).toFixed(dec);
      var parts = n.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + th);
      return dollars + (parts[1] && dec > 0 ? ds + parts[1] : '');
    }
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var v = '';
    switch (m ? m[1] : 'amount') {
      case 'amount': v = fmt(cents, 2); break;
      case 'amount_no_decimals': v = fmt(cents, 0); break;
      case 'amount_with_comma_separator': v = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = fmt(cents, 2, "'"); break;
      default: v = fmt(cents, 2);
    }
    v = v.replace(/[,.]00$/, '');
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, v);
  }
  A.formatMoney = formatMoney;

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* ---------- Cart drawer ---------- */
  var drawer = $('[data-cart-drawer]');
  var lastFocus = null;
  function setCount(n) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = !n; });
  }
  function renderCart(cart) {
    setCount(cart.item_count);
    if (!drawer) return;
    var box = $('[data-cart-items]', drawer);
    var ship = $('[data-cart-ship]', drawer);
    var th = A.freeShipping || 99900;
    if (cart.item_count === 0) {
      box.innerHTML = '<div class="cd-empty"><p>Din kurv er tom.</p><a class="btn turq" href="/collections/alle-produkter">Se alle produkter</a></div>';
      ship.innerHTML = '';
      $('[data-cart-total]', drawer).textContent = formatMoney(0);
      drawer.classList.add('is-empty');
      return;
    }
    drawer.classList.remove('is-empty');
    var left = th - cart.total_price;
    var pct = Math.min(100, Math.round(cart.total_price / th * 100));
    ship.innerHTML = (left > 0 ? '<p>Du mangler <b>' + formatMoney(left) + '</b> for at få fri fragt.</p>' : '<p><b>Du har fri fragt</b> på din ordre.</p>') + '<span class="cd-bar"><i style="width:' + pct + '%"></i></span>';
    box.innerHTML = cart.items.map(function (it, i) {
      var img = it.image ? '<img src="' + it.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') + '" alt="" width="80" height="80" loading="lazy">' : '';
      var variant = it.variant_title && it.variant_title !== 'Default Title' ? '<small>' + esc(it.variant_title) + '</small>' : '';
      var disc = (it.line_level_discount_allocations || []).filter(function (d) { return d.amount > 0; }).map(function (d) { return '<small class="disc">' + esc(d.discount_application.title) + ' (−' + formatMoney(d.amount) + ')</small>'; }).join('');
      var was = it.original_line_price !== it.final_line_price ? '<s>' + formatMoney(it.original_line_price) + '</s>' : '';
      return '<div class="cdi" data-line="' + (i + 1) + '">' +
        '<a class="cdi-img" href="' + it.url + '">' + img + '</a>' +
        '<div class="cdi-t"><a href="' + it.url + '"><b>' + esc(it.product_title) + '</b></a>' + variant + disc +
        '<div class="cdi-q"><button type="button" data-q="-1" aria-label="Færre">−</button><span>' + it.quantity + '</span><button type="button" data-q="1" aria-label="Flere">+</button><button class="cdi-rm" type="button" data-rm>Fjern</button></div></div>' +
        '<div class="cdi-p">' + was + '<b>' + formatMoney(it.final_line_price) + '</b></div></div>';
    }).join('');
    $('[data-cart-total]', drawer).textContent = formatMoney(cart.total_price);
  }
  function fetchCart() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function openDrawer() {
    if (!drawer) { location.href = '/cart'; return; }
    lastFocus = document.activeElement;
    drawer.hidden = false;
    requestAnimationFrame(function () { drawer.classList.add('open'); });
    document.documentElement.classList.add('no-scroll');
    var x = $('.cd-x', drawer); if (x) x.focus();
    fetchCart().then(renderCart);
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('open');
    document.documentElement.classList.remove('no-scroll');
    setTimeout(function () { drawer.hidden = true; }, 250);
    if (lastFocus) lastFocus.focus();
  }
  A.openCart = openDrawer;
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-cart-open]');
    if (o && drawer) { e.preventDefault(); openDrawer(); return; }
    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); closeDrawer(); return; }
    var line = e.target.closest('[data-line]');
    if (line && (e.target.closest('[data-q]') || e.target.closest('[data-rm]'))) {
      var cur = parseInt($('.cdi-q span', line).textContent, 10);
      var q = e.target.closest('[data-rm]') ? 0 : Math.max(0, cur + parseInt(e.target.closest('[data-q]').getAttribute('data-q'), 10));
      line.classList.add('busy');
      fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: parseInt(line.getAttribute('data-line'), 10), quantity: q }) })
        .then(function (r) { return r.json(); }).then(renderCart);
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer && !drawer.hidden) closeDrawer(); });

  /* ---------- Product page ---------- */
  var page = $('[data-product-page]');
  if (page) {
    var form = $('[data-pform]', page);
    var pjEl = $('[data-product-json]', page);
    var product = pjEl ? JSON.parse(pjEl.textContent) : null;

    function showMedia(id) {
      $$('.gm', page).forEach(function (m) { m.classList.toggle('on', m.getAttribute('data-media') == id); });
      $$('[data-thumb]', page).forEach(function (t) { t.classList.toggle('on', t.getAttribute('data-thumb') == id); });
    }
    $$('[data-thumb]', page).forEach(function (t) { t.addEventListener('click', function () { showMedia(t.getAttribute('data-thumb')); }); });

    $$('[data-qty]', page).forEach(function (b) {
      b.addEventListener('click', function () {
        var inp = $('input[name="quantity"]', page);
        inp.value = Math.max(1, (parseInt(inp.value, 10) || 1) + parseInt(b.getAttribute('data-qty'), 10));
      });
    });

    function currentOptions() {
      var opts = [];
      $$('.vopt', page).forEach(function (fs, i) { var c = $('input:checked', fs); opts[i] = c ? c.value : null; });
      return opts;
    }
    function updateVariant() {
      if (!product) return;
      var opts = currentOptions();
      var v = product.variants.find(function (x) { return x.options.every(function (o, i) { return o === opts[i]; }); });
      var btn = $('[data-add]', page);
      if (!v) { if (btn) { btn.disabled = true; btn.textContent = 'Ikke tilgængelig'; } return; }
      $('[data-variant-id]', page).value = v.id;
      $$('[data-price]', page).forEach(function (el) { el.textContent = formatMoney(v.price); });
      var cmp = $('[data-compare]', page), sv = $('[data-save]', page);
      if (cmp) { cmp.hidden = !(v.compare_at_price > v.price); cmp.textContent = formatMoney(v.compare_at_price || 0); }
      if (sv) { sv.hidden = !(v.compare_at_price > v.price); sv.textContent = 'Spar ' + formatMoney((v.compare_at_price || 0) - v.price); }
      var ap = $('[data-anyday-price]', page); if (ap) ap.textContent = formatMoney(v.price);
      var st = $('[data-stock]', page);
      if (st) { st.classList.toggle('out', !v.available); st.innerHTML = '<i></i>' + (v.available ? 'På lager' : 'Udsolgt'); }
      if (btn) { btn.disabled = !v.available; btn.firstChild.textContent = v.available ? 'Læg i kurv ' : 'Udsolgt '; }
      if (v.featured_media) showMedia(v.featured_media.id);
      var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u);
    }
    $$('.vopt input', page).forEach(function (i) { i.addEventListener('change', updateVariant); });

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = $('[data-add]', form);
        var err = $('[data-form-err]', form);
        var qty = parseInt(($('input[name="quantity"]', form) || {}).value, 10) || 1;
        var items = [{ id: parseInt($('[data-variant-id]', form).value, 10), quantity: qty }];
        var w = $('[data-warranty]:checked', form);
        if (w && w.value) items.push({ id: parseInt(w.value, 10), quantity: qty });
        $$('[data-addon]:checked', form).forEach(function (a) { items.push({ id: parseInt(a.value, 10), quantity: 1 }); });
        if (btn) btn.classList.add('busy');
        if (err) err.hidden = true;
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
          .then(function (res) {
            if (btn) btn.classList.remove('busy');
            if (!res.ok) { if (err) { err.textContent = res.j.description || res.j.message || 'Noget gik galt. Prøv igen.'; err.hidden = false; } return; }
            openDrawer();
          })
          .catch(function () { form.submit(); });
      });
      var sb = $('[data-sbar-add]', page);
      if (sb) sb.addEventListener('click', function () { if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true })); });
      var sbar = $('[data-sbar]', page);
      var addBtn = $('[data-add]', form);
      if (sbar && addBtn && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (en) { sbar.classList.toggle('show', !en[0].isIntersecting && en[0].boundingClientRect.top < 0); }).observe(addBtn);
      }
    }
    // subnav active state
    var links = $$('.subnav a', page);
    if (links.length && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) links.forEach(function (l) { l.classList.toggle('on', l.getAttribute('href') === '#' + en.target.id); });
        });
      }, { rootMargin: '-40% 0px -55% 0px' });
      links.forEach(function (l) { var t = document.querySelector(l.getAttribute('href')); if (t) io.observe(t); });
    }
  }

  /* ---------- Collection sort ---------- */
  $$('[data-sort]').forEach(function (s) {
    s.addEventListener('change', function () { var u = new URL(location.href); u.searchParams.set('sort_by', s.value); u.searchParams.delete('page'); location.href = u; });
  });

  /* ---------- Menu: close on outside click ---------- */
  document.addEventListener('click', function (e) {
    $$('details.menu[open]').forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
  });

  /* ---------- B2B catalog form: build tags from chosen catalogs ---------- */
  $$('[data-kat-form], #b2b-katalog').forEach(function (f) {
    var all = $('input[value="alle"]', f);
    if (all) all.addEventListener('change', function () { $$('input[name="kat"]', f).forEach(function (c) { if (c !== all) c.checked = all.checked; }); });
    f.addEventListener('submit', function (e) {
      var chosen = $$('input[name="kat"]:checked', f).map(function (c) { return c.value; }).filter(function (v) { return v !== 'alle'; });
      var err = $('[data-kat-err]', f);
      if (!chosen.length) { e.preventDefault(); if (err) { err.hidden = false; err.textContent = 'Vælg mindst ét katalog.'; } return; }
      var tags = ['b2b-katalog'].concat(chosen.map(function (v) { return 'katalog-' + v; }));
      $('[data-kat-tags]', f).value = tags.join(', ');
      var note = $('[data-kat-note]', f);
      if (note) {
        var phone = ($('[data-kat-phone]', f) || {}).value || '';
        var comp = ($('[data-kat-company]', f) || {}).value || '';
        note.value = 'B2B-katalog: ' + chosen.join(', ') + (phone ? ' | Tlf: ' + phone : '') + (comp ? ' | Virksomhed: ' + comp : '');
      }
    });
  });

  /* ---------- Form success: only show for the form that was sent ---------- */
  var postedId = null;
  try { postedId = sessionStorage.getItem('asc_posted'); sessionStorage.removeItem('asc_posted'); } catch (e) {}
  $$('form').forEach(function (f) { f.addEventListener('submit', function () { try { sessionStorage.setItem('asc_posted', f.id || ''); } catch (e) {} }); });
  var kf = document.getElementById('b2b-katalog');
  if (kf) kf.addEventListener('submit', function () {
    var v = $$('input[name="kat"]:checked', kf).map(function (i) { return i.value; });
    try { sessionStorage.setItem('asc_kat', JSON.stringify(v)); } catch (e) {}
  });
  if (postedId === 'b2b-katalog') {
    var ul = $('[data-kat-links]'), mapEl = document.getElementById('kat-files');
    if (ul && mapEl) {
      var map = {}, sel = [];
      try { map = JSON.parse(mapEl.textContent); } catch (e) {}
      try { sel = JSON.parse(sessionStorage.getItem('asc_kat') || '[]'); } catch (e) {}
      if (!sel.length || sel.indexOf('alle') > -1) sel = Object.keys(map);
      ul.innerHTML = sel.filter(function (k) { return map[k]; }).map(function (k) { return '<li><a href="' + map[k][1] + '" target="_blank" rel="noopener">' + map[k][0] + ' (PDF)</a></li>'; }).join('');
    }
  }
  $$('[data-ok-for]').forEach(function (el) {
    if (postedId && el.getAttribute('data-ok-for') === postedId) {
      el.hidden = false;
      var body = el.parentNode.querySelector('[data-form-body]'); if (body) body.hidden = true;
      if (postedId !== 'PopupNewsletter') { var t = document.getElementById(postedId); if (t) setTimeout(function () { t.scrollIntoView({ block: 'center' }); }, 50); }
    }
  });

  /* ---------- Newsletter popup ---------- */
  var pop = $('[data-popup]');
  if (pop) {
    var key = 'asc_pop_v1', seen = null;
    try { seen = localStorage.getItem(key); } catch (e) {}
    var posted = postedId === 'PopupNewsletter' && !!pop.querySelector('[data-posted-ok]');
    function closePop() { pop.classList.remove('open'); setTimeout(function () { pop.hidden = true; }, 250); try { localStorage.setItem(key, String(Date.now())); } catch (e) {} }
    if (posted) { pop.hidden = false; pop.classList.add('open'); }
    else if (!seen || Date.now() - parseInt(seen, 10) > 1000 * 60 * 60 * 24 * 14) {
      setTimeout(function () { if (!document.documentElement.classList.contains('no-scroll')) { pop.hidden = false; requestAnimationFrame(function () { pop.classList.add('open'); }); } }, parseInt(pop.getAttribute('data-delay') || '8', 10) * 1000);
    }
    $$('[data-popup-close]', pop).forEach(function (b) { b.addEventListener('click', closePop); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !pop.hidden) closePop(); });
  }
})();
